import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

function CheckIcon(){

    const accessibility = useAccessibility();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="57" viewBox="0 0 56 57" fill="none">
            <g clip-path="url(#clip0_3365_16354)">
                <path d="M40.3593 19.6407C41.3874 20.6688 41.3874 22.3313 40.3593 23.3485L26.3593 37.3595C25.3312 38.3876 23.6687 38.3876 22.6515 37.3595L15.6515 30.3595C14.6233 29.3313 14.6233 27.6688 15.6515 26.6517C16.6796 25.6345 18.3421 25.6235 19.3593 26.6517L24.4999 31.7923L36.6405 19.6407C37.6687 18.6126 39.3312 18.6126 40.3483 19.6407H40.3593Z" fill={accessibility.contrastMode ? accessibility.contrastColor : "#00995D"} />
                <path opacity="0.4" d="M28 56.5C35.4261 56.5 42.548 53.55 47.799 48.299C53.05 43.048 56 35.9261 56 28.5C56 21.0739 53.05 13.952 47.799 8.70101C42.548 3.44999 35.4261 0.5 28 0.5C20.5739 0.5 13.452 3.44999 8.20101 8.70101C2.94999 13.952 0 21.0739 0 28.5C0 35.9261 2.94999 43.048 8.20101 48.299C13.452 53.55 20.5739 56.5 28 56.5ZM40.3594 23.3594L26.3594 37.3594C25.3313 38.3875 23.6688 38.3875 22.6516 37.3594L15.6516 30.3594C14.6234 29.3313 14.6234 27.6688 15.6516 26.6516C16.6797 25.6344 18.3422 25.6234 19.3594 26.6516L24.5 31.7922L36.6406 19.6406C37.6687 18.6125 39.3312 18.6125 40.3484 19.6406C41.3656 20.6687 41.3766 22.3312 40.3484 23.3484L40.3594 23.3594Z" fill={accessibility.contrastMode ? accessibility.contrastColor : "#00995D"}/>
            </g>
            <defs>
                <clipPath id="clip0_3365_16354">
                <rect width="56" height="56" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default CheckIcon;